var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEducationIconBlack = function SvgEducationIconBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4902 9.13L18.2802 9.66997L18.0202 9.78997L17.3102 10.1L12.1902 12.38C12.0602 12.44 11.9402 12.47 11.8002 12.49C11.5902 12.53 11.3702 12.53 11.1602 12.49C11.0202 12.47 10.9002 12.44 10.7702 12.38L5.65017 10.1L4.94018 9.78997L4.68017 9.66997L3.47018 9.13C2.50018 8.7 2.50018 7.59997 3.47018 7.16997L10.7702 3.91997C11.2102 3.73997 11.7502 3.73997 12.1902 3.91997L19.4902 7.16997C20.4602 7.58997 20.4602 8.7 19.4902 9.13Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3102 10.1V13.93C17.3102 14.27 17.1501 14.59 16.8601 14.78C15.9201 15.4 14.0302 16.41 11.4802 16.41C10.7002 16.41 8.40016 16.32 6.10016 14.78C5.82016 14.59 5.66016 14.27 5.66016 13.93V10.11L10.7802 12.39C10.9102 12.45 11.0302 12.48 11.1702 12.5C11.3802 12.54 11.6002 12.54 11.8102 12.5C11.9502 12.48 12.0702 12.45 12.2002 12.39L17.3102 10.1Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2202 8.15002V17.14",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2204 15.36C19.2404 15.36 18.4404 16.16 18.4404 17.14C18.4404 18.12 19.2404 18.92 20.2204 18.92C21.2004 18.92 22.0004 18.12 22.0004 17.14C22.0004 16.16 21.2004 15.36 20.2204 15.36Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2202 18.17V20.22",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEducationIconBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/educationIconBlack.00baf017.svg";
export { ForwardRef as ReactComponent };